






















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { RainbowColor } from '@getaccept/lib-ui';

export default defineComponent({
  props: {
    text: {
      type: String,
      default: '',
    },
    link: {
      type: Object as PropType<{ text: string; url: string }>,
      default: null,
    },
  },
  emits: ['contact'],
  setup() {
    return {
      RainbowColor,
      t,
    };
  },
});
